import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import { UserContext } from '../UserContext';
import ShowAnswers from './ShowAnswers';

import React, { useState, useEffect, useContext } from 'react';

import { useLocation } from 'react-router';

import { withAuthenticator } from 'aws-amplify-react';

import * as styles from './dashboard.style';
import { button } from '../../styles/components/buttons.style';

import { container } from '../quizApp.style';
import { find, last, isEmpty, orderBy } from 'lodash';
import coinImg from '../../assets/images/coin-img.png';

import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';

Amplify.configure(config);

function Dashboard(props) {
  const { user } = useContext(UserContext);
  // const [isOpen, setIsOpen] = useState(false);
  const [username, setUsername] = useState('');
  const [correctAns, setCorrectAns] = useState(0);
  const [inCorrectAns, setInCorrectAns] = useState(0);
  const [currentUser, setCurrentUser] = useState({});
  const [totalQuestion, setTotalQuestion] = useState(0);
  const [questionAnswered, setQuestionAnswered] = useState(0);

  function goback() {
    setCurrentUser({});
    setUsername('');
  }

  const [events, set_events] = useState([]);

  // const getToken = async (id) => {
  //   Auth.currentSession().then((res) => {
  //     let accessToken = res.getAccessToken();
  //     let jwt = accessToken.getJwtToken();

  //     getEventsfromDB(Auth.user.username, jwt, id);
  //   });
  // };



  const getToken = async (id) => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {



          getEventsfromDB(user.attributes['email'], jwt, id)





        }
        else {



          ////console.log("Called getuserDetails")
          getEventsfromDB(user.username, jwt, id)



        }




      });




    } catch (error) {
      console.log(error)
      Auth.signOut()
    }
  };




  const getEventsfromDB = async (username, jwt, id) => {
    // const category = data1.state;

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({
        username: username,
        eventid: id,
        eventtype: 'Assignments',
      }),
    };

    ////console.log(requestOptions)
    const response = await fetch(
      `https://api.quizwizard.net/quiz/getassignmentmarks`,
      requestOptions
    );
    const data = await response.json();
    console.log('Output from the API is ')
    set_events(data);
    console.log(events)
  };

  let data1 = useLocation();

  useEffect(() => {
    ////console.log("useEffect called in EditBatch")
    ////console.log(data1.state["id"])
    getToken(data1.state['id']);
    document.title = 'LeaderBoard';

  }, []);

  useEffect(() => {
    if (isEmpty(currentUser)) return;
    Object.entries(currentUser.useranswers).forEach((value) => {
      const parsedValue = JSON.parse(last(value));

      if (
        parsedValue.correctanswer.replace('Spell', '').trim() ===
        parsedValue.useranswer.replace('Spell', '').trim()
      ) {
        setCorrectAns((state) => state + 1);
      } else {
        setInCorrectAns((state) => state + 1);
      }
      if (parsedValue.useranswer.replace('Spell', '').length) {
        setQuestionAnswered((state) => state + 1);
      }
    });
    setTotalQuestion(Object.keys(currentUser.useranswers).length);
  }, [currentUser]);

  const percentage = totalQuestion ? Math.round((correctAns / totalQuestion) * 100) : 0;

  useEffect(() => {
    if (username.length) setCurrentUser(find(events, { username }));
  }, [username]);

  if (!isEmpty(currentUser)) {
    return (
      <div className="container">
        <div className={styles.img}>
          <img
            src={
              user['profilepic'] &&
              require(`../../assets/images/${user['profilepic']}.jpg`).default
            }
            alt=""
          />
        </div>
        <p className={styles.title}>{currentUser.username}</p>
        <p className={styles.line}>
          Awesome, You are doing great. Your overall progress is{' '}
          <span>{percentage}%</span>.
        </p>{' '}
        {!isEmpty(currentUser) ? (
          <>
            <div className={styles.summary}>
              <p className="s-title">{percentage}%</p>
              <p className="sub-title">{currentUser.eventname}</p>
              <p className="line">
                {questionAnswered}/{totalQuestion} questions answered
              </p>
              <div className="row">
                <div className="item">
                  <p style={{ '--color': '#2ec32b' }} className="item-title">
                    {correctAns}
                  </p>
                  <p className="line no-margin">Correct answer</p>
                </div>
                <div className="item">
                  <p style={{ '--color': '#c32b2b' }} className="item-title">
                    {inCorrectAns}
                  </p>
                  <p className="line no-margin">Incorrect answer</p>
                </div>
              </div>
            </div>
            <ShowAnswers
              useranswers={currentUser.useranswers}
              username={currentUser.username}
              userscore={currentUser.score}
            />
          </>
        ) : null}
        <p>&nbsp;</p>
        <div className="text-center">
          <button className={button} onClick={goback}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="container">
      <div className={`${container} no-shadow`}>
        <p className={styles.title}>
          <span>L</span>
          <span>e</span>
          <span>a</span>
          <span>d</span>
          <span>e</span>
          <span>r</span>
          <span>b</span>
          <span>o</span>
          <span>a</span>
          <span>r</span>
          <span>d</span>
        </p>

        <img
          className={styles.glitter}
          src={require('../../assets/images/glitter.jpeg').default}
          alt=""
        />

        <div className={styles.list}>
          {isEmpty(events) ? (
            <Lottie options={defaultOptions} height={200} width={200} />
          ) : (
            orderBy(events, 'latestscore', 'desc').map((evt, index) => (
              <button
                onClick={() => {
                  setUsername(evt.username);
                  setCorrectAns(0);
                  setInCorrectAns(0);
                  setQuestionAnswered(0);
                }}
                type="button"
                className={styles.listItem}
                key={evt.eventid}
              >
                <span className="count">{index + 1}</span>
                <img
                  className="avatar"
                  src={
                    user['profilepic'] &&
                    require(`../../assets/images/${user['profilepic']}.jpg`)
                      .default
                  }
                  alt=""
                />
                <p className="username">{evt.username}</p>
                <p className="points">
                  <img src={coinImg} alt="" />
                  {evt.latestscore} score
                </p>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
